import { Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "../App/App.css";
import Header from "../Header/Header";
import Main from "../Main/Main";
import Footer from "../Footer/Footer";
import Cookies from "../Policy/Cookies";
import Privacy from "../Policy/Privacy";
import Popup from "../Popup/Popup";
import HowToPlay from "../HowToPlay/HowToPlay";
import DrawResults from "../DrawResults/DrawResults";
import Winners from "../Winners/Winners";
import AboutLottery from "../AboutLottery/AboutLottery";
import ResponsibleGaming from "../Policy/ResponsibleGaming";
import Register from "../Register/Register";
import { useState } from "react";

function App() {
  const [isRegisterPopup, setIsRegisterPopup] = useState(false);
  return (
    <HelmetProvider>
      <div className="lottolegenda-page">
        <Header />
        <Routes>
          <Route path="/" element={<Main />} />
          <Route
            path="/how-to-play"
            element={<HowToPlay setIsRegisterPopup={setIsRegisterPopup} />}
          />
          <Route
            path="/results"
            element={<DrawResults setIsRegisterPopup={setIsRegisterPopup} />}
          />
          <Route path="/winners" element={<Winners />} />
          <Route path="/about" element={<AboutLottery />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/responsible-gaming" element={<ResponsibleGaming />} />
        </Routes>
        <Footer />
        <Popup />
        <Register
          isRegisterPopup={isRegisterPopup}
          setIsRegisterPopup={setIsRegisterPopup}
        />
      </div>
    </HelmetProvider>
  );
}

export default App;
